import React from 'react'
import { graphql } from 'gatsby'
import './MobileBanner.scss'

export default function MobileBanner({text, video}) {
	return(
		<div className="MobileBanner Block">
			{	video && video.localFile && video.localFile.publicURL &&
				<video className="media" autoPlay muted loop playsInline>
					<source src={video.localFile.publicURL} type="video/mp4" />
				</video>
			}
			{
				text &&
				<div className="banner-text">
					<p><span>{text}</span></p>
				</div>
			}
		</div>
	)
}

export const query = graphql`
	fragment MobileBanner on WpPage_Layout_block_Layout_MobileBanner {
		fieldGroupName
		text
		video {
			localFile {
				publicURL
			}
		}
	}
`;